import { useDispatch, useSelector } from "react-redux";
import { selectUncommittedGroupTypeEntity } from "./selector";
import { useEffect } from "react";
import { requestGroups } from "./actions";
import SelectionState from "state/selections/SelectionState";
import { selectAsOfDateValue } from "state/selections/selector";

export const useRequestGroupsEffect = () => {
  const asOfDateValue = useSelector(
    selectAsOfDateValue(SelectionState.UNCOMMITTED)
  );
  const groupTypeEntity = useSelector(selectUncommittedGroupTypeEntity);
  const dispatch = useDispatch();

  useEffect(() => {
    if (asOfDateValue && groupTypeEntity) {
      dispatch(requestGroups(groupTypeEntity, asOfDateValue));
    }
  }, [asOfDateValue, groupTypeEntity, dispatch]);
};